const Quiz = (domEl) => {
	if(!domEl) {
		return;
	}

	let currentQuizItemIndex = 1;
	const totalQuizItems = domEl.querySelectorAll('.quiz-item').length;
	let isShowingResult = false;
	let totalCorrect = 0;



	const onAnswerClicked = (e) => {
		e.preventDefault();
		if(isShowingResult) {
			return;
		}
		isShowingResult = true;


		e.currentTarget.classList.add('js-clicked');

		const quizItemIndex = parseInt(e.currentTarget.dataset.quizItemIndex)
		const isCorrect = e.currentTarget.dataset.correct === "true";
		const quizItemElement = domEl.querySelector(`.quiz-item[data-index="${quizItemIndex}"]`);
		if(isCorrect) {
			totalCorrect++;
		}

		// Show the result
		setTimeout(() => {

			// Show result
			quizItemElement.querySelector(`.result-heading[data-correct="${isCorrect ? "true" : "false" }"]`).style.display = 'block';
			quizItemElement.classList.add('js-show-result');

			// Mark the progress
			domEl.querySelector(`.progress-item[data-index="${quizItemIndex}"]`).classList.add( isCorrect ? 'js-correct' : 'js-incorrect' );

			// Mark the media
			domEl.querySelector(`.wp-block-media-text__media[data-index="${quizItemIndex}"]`).classList.add( isCorrect ? 'js-correct' : 'js-incorrect' );
		}, 500)
	}

	const onContinueBtnClicked = (e) => {
		e.preventDefault();
		currentQuizItemIndex++;

		if(currentQuizItemIndex <= totalQuizItems) {

			domEl.querySelectorAll('.quiz-item').forEach((quizItem) => {
				quizItem.style.display = ( parseInt(quizItem.dataset.index) === currentQuizItemIndex ? "block" : "none" );
				quizItem.setAttribute('aria-hidden', parseInt(quizItem.dataset.index) === currentQuizItemIndex ? "true" : "false" );
			});

			domEl.querySelectorAll('.wp-block-media-text__media').forEach(media => {
				media.style.display = ( parseInt(media.dataset.index) === currentQuizItemIndex ? "block" : "none" );
			});

			isShowingResult = false;
		}
		else {
			//totalCorrect
			domEl.querySelectorAll('.quiz-item').forEach(quizItem => quizItem.style.display = "none");
			domEl.querySelectorAll('.end-result').forEach((endResult) => {
				endResult.style.display = ( parseInt(endResult.dataset.correctAnswers) === totalCorrect ? "block" : "none" );
				endResult.setAttribute('aria-hidden', parseInt(endResult.dataset.correctAnswers) === totalCorrect ? "true" : "false" );
			});

			domEl.querySelector('.media-end-result').innerText = `${totalCorrect}/${totalQuizItems}`;
			domEl.querySelector('.media-end-result').classList.add('js-active');
		}
	}

	domEl.querySelectorAll('.answer button').forEach(answerEl => {
		answerEl.addEventListener('click', onAnswerClicked);
	})

	domEl.querySelectorAll('.continue-btn').forEach(continueBtn => {
		continueBtn.addEventListener('click', onContinueBtnClicked);
	})
}

export default Quiz;